module.exports = __webpack_public_path__ + "img/guide_2.00f5a075.png";